import { useState } from 'react';
import { Button } from '@/components/shadcn-ui/button';
import { Copy, Check } from 'lucide-react';

export function ExtractedDataView({ data, title = "Extracted Data" }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        const jsonString = JSON.stringify(data, null, 2);
        navigator.clipboard.writeText(jsonString);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    // If no data, show empty state
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
        return (
            <div className="text-muted-foreground text-center py-8">
                No extracted data available
            </div>
        );
    }

    return (
        <div className="bg-muted  rounded-lg overflow-hidden">
            {/* Header with Title and Copy Button */}
            <div className="flex items-center justify-between px-4 py-3 border-b ">
                <div className="flex items-center gap-2">
                    <span className="text-sm font-mono text-black">&lt;/&gt;</span>
                    <span className="text-sm font-medium text-black">{title}</span>
                </div>
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={handleCopy}
                    className="h-8 px-3 text-black hover:text-black/80 hover:bg-muted/50"
                >
                    {copied ? (
                        <>
                            <Check className="h-4 w-4 mr-1" />
                            Copied
                        </>
                    ) : (
                        <>
                            <Copy className="h-4 w-4 mr-1" />
                            Copy
                        </>
                    )}
                </Button>
            </div>

            {/* JSON Content */}
            <div className=" bg-muted p-4 overflow-x-auto">
                <pre className="text-sm text-black font-mono">
                    <code>{JSON.stringify(data, null, 2)}</code>
                </pre>
            </div>
        </div>
    );
}

